import React from 'react';
import { compose, graphql } from 'react-apollo';
import gql from 'graphql-tag';
import USER_QUERY from 'components/MainLayout/graphql/userQuery.gql';

// import LiteCheckout from 'containers/Lite/Checkout/Loadable';
import Checkout from 'containers/Checkout/Loadable';

class CheckoutSwitch extends React.PureComponent {
  render() {
    const { userQuery, ...rest } = this.props;
    const currentUser = (userQuery && userQuery.user) ? userQuery.user : false;
    // const isLite = true;

    if (currentUser) {
      // if (isLite) return <LiteCheckout {...this.props} />;

      return <Checkout {...rest} />;
    }

    return null;
  }
}

const IS_TOKEN = gql`
  query IsToken {
    isToken
  }
`;

export default compose(
  graphql(IS_TOKEN, {
    options: { fetchPolicy: 'cache-only' },
    props: ({ data: { isToken } }) => ({
      isToken,
    }),
  }),
  graphql(USER_QUERY, {
    name: 'userQuery',
    skip: (ownProps) => !ownProps.isToken,
  })
)(CheckoutSwitch);



// WEBPACK FOOTER //
// ./app/containers/Checkout/Switch.js